"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orderCardStyleMap = exports.OrderList = exports.OrderCardType = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _clsx3 = _interopRequireDefault(require("clsx"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _Order = require("../Order");
var _Button = require("../Button");
var _Popup = require("../Popup");
var _order_others = _interopRequireDefault(require("../../assets/images/order_others.png"));
var _ProductList = require("../ProductList");
var _LocaleProvider = require("../LocaleProvider");
var _constants = require("../../utils/constants");
var _useTracking = require("../../hooks/useTracking");
var _elementScrollTrack = require("../../utils/tracking/elementScrollTrack");
var _orderCardStyleMap;
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var OrderCardType;
exports.OrderCardType = OrderCardType;
(function (OrderCardType) {
  OrderCardType[OrderCardType["oldCarousel"] = 0] = "oldCarousel";
  OrderCardType[OrderCardType["newCarousel"] = 1] = "newCarousel";
  OrderCardType[OrderCardType["bigCarousel"] = 2] = "bigCarousel";
  OrderCardType[OrderCardType["verticalList"] = 3] = "verticalList";
  OrderCardType[OrderCardType["twoRowCarousel"] = 4] = "twoRowCarousel";
  OrderCardType[OrderCardType["foodCardInList"] = 5] = "foodCardInList";
  OrderCardType[OrderCardType["orderWithCopy"] = 6] = "orderWithCopy";
  OrderCardType[OrderCardType["smallOrder"] = 7] = "smallOrder";
  OrderCardType[OrderCardType["foodCard"] = 8] = "foodCard";
  OrderCardType[OrderCardType["expeditedDelivery"] = 9] = "expeditedDelivery";
})(OrderCardType || (exports.OrderCardType = OrderCardType = {}));
var orderCardStyleMap = (_orderCardStyleMap = {}, (0, _defineProperty2.default)(_orderCardStyleMap, OrderCardType.oldCarousel, ''), (0, _defineProperty2.default)(_orderCardStyleMap, OrderCardType.newCarousel, 'new-carousel'), (0, _defineProperty2.default)(_orderCardStyleMap, OrderCardType.bigCarousel, 'big-carousel'), (0, _defineProperty2.default)(_orderCardStyleMap, OrderCardType.verticalList, 'vertical-list'), (0, _defineProperty2.default)(_orderCardStyleMap, OrderCardType.twoRowCarousel, 'two-row-carousel'), (0, _defineProperty2.default)(_orderCardStyleMap, OrderCardType.foodCardInList, 'food-card-in-list'), (0, _defineProperty2.default)(_orderCardStyleMap, OrderCardType.orderWithCopy, 'order-with-copy'), (0, _defineProperty2.default)(_orderCardStyleMap, OrderCardType.smallOrder, 'small-order'), (0, _defineProperty2.default)(_orderCardStyleMap, OrderCardType.foodCard, 'food-card'), (0, _defineProperty2.default)(_orderCardStyleMap, OrderCardType.expeditedDelivery, 'expedited-delivery'), _orderCardStyleMap);
exports.orderCardStyleMap = orderCardStyleMap;
var OrderList = function OrderList(props) {
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    showTime = _useState2[0],
    setShowTime = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    showPopup = _useState4[0],
    setShowPopup = _useState4[1];
  var containerRef = (0, _react.useRef)(null);
  var ordersRef = (0, _react.useRef)(null);
  var _useLocale = (0, _LocaleProvider.useLocale)(),
    trans = _useLocale.trans;
  var showMoreOrderButton = props.showMoreOrderButton,
    _props$content = props.content,
    content = _props$content === void 0 ? [] : _props$content,
    loadMoreOrderText = props.loadMoreOrderText,
    selectOrderText = props.selectOrderText,
    tabs = props.tabs,
    onLoadMore = props.onLoadMore,
    defaultSelected = props.defaultSelected,
    _props$maxDisplay = props.maxDisplay,
    maxDisplay = _props$maxDisplay === void 0 ? 5 : _props$maxDisplay,
    itemText = props.itemText,
    itemsText = props.itemsText,
    panelTitleText = props.panelTitleText,
    userTypes = props.userTypes,
    showUserTypeTab = props.showUserTypeTab,
    _props$showScrollbar = props.showScrollbar,
    showScrollbar = _props$showScrollbar === void 0 ? false : _props$showScrollbar,
    _onButtonClick = props.onButtonClick,
    componentTrackingData = props.componentTrackingData,
    _props$showOrderId = props.showOrderId,
    showOrderId = _props$showOrderId === void 0 ? false : _props$showOrderId,
    _props$orderCardType = props.orderCardType,
    orderCardType = _props$orderCardType === void 0 ? OrderCardType.oldCarousel : _props$orderCardType,
    _props$showLoading = props.showLoading,
    showLoading = _props$showLoading === void 0 ? true : _props$showLoading,
    totalText = props.totalText,
    onClosePopup = props.onClosePopup,
    onOrderClick = props.onOrderClick,
    onShowMoreButtonClick = props.onShowMoreButtonClick,
    previewMockData = props.previewMockData,
    formatOrderListItem = props.formatOrderListItem,
    statusText = props.statusText;
  var elementScrollTrack = (0, _react.useMemo)(function () {
    return new _elementScrollTrack.ElementScrollTrackManage();
  }, []);
  var _useComponentTracking = (0, _useTracking.useComponentTracking)(props),
    tracker = _useComponentTracking.tracker,
    result = _useComponentTracking.result;
  var moreOrderTracking = result.moreOrder,
    orderListTrackData = result.orderList,
    closePanelTrackingData = result.closePanel;
  var trackingData = componentTrackingData === null || componentTrackingData === void 0 ? void 0 : componentTrackingData.panelOrder;
  var handleMoreOrderClick = function handleMoreOrderClick() {
    setShowPopup(true);
    onShowMoreButtonClick === null || onShowMoreButtonClick === void 0 ? void 0 : onShowMoreButtonClick();
    (moreOrderTracking === null || moreOrderTracking === void 0 ? void 0 : moreOrderTracking.trackingClick) && tracker.click(moreOrderTracking.trackingClick);
  };
  var prefixCls = (0, _getPrefixCls.getPrefixCls)('order-list');
  var renderOrder = function renderOrder(props) {
    var index = props.index;
    if (orderCardType !== OrderCardType.twoRowCarousel) {
      return index < maxDisplay && renderOrderItem(props);
    }
    return renderTwoRowCarousel(props);
  };
  var renderTwoRowCarousel = function renderTwoRowCarousel(props) {
    var index = props.index,
      order = props.order;
    if (index % 2 !== 0) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "-item-container"),
      key: order.orderId
    }, renderOrderItem(props), index + 1 < content.length && renderOrderItem({
      order: content[index + 1],
      index: index + 1
    }));
  }; // TODO: useCallback

  var renderOrderItem = function renderOrderItem(props) {
    var order = props.order,
      index = props.index;
    var _useComponentTracking2 = (0, _useTracking.useComponentTracking)({
        componentTrackingData: componentTrackingData,
        componentData: {
          order: order,
          index: index
        }
      }),
      tracker = _useComponentTracking2.tracker,
      orderTracking = _useComponentTracking2.result.order;
    var handleCardClick = function handleCardClick() {
      onOrderClick === null || onOrderClick === void 0 ? void 0 : onOrderClick();
      (orderTracking === null || orderTracking === void 0 ? void 0 : orderTracking.trackingClick) && tracker.click(orderTracking.trackingClick);
    };
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      className: (0, _clsx3.default)("".concat(prefixCls, "-item"), 'chatbot-order-list-item'),
      key: order.orderId,
      onClick: handleCardClick
    }, orderTracking === null || orderTracking === void 0 ? void 0 : orderTracking.trackingImpressionProps), /*#__PURE__*/_react.default.createElement(_Order.Order, (0, _extends2.default)({}, order, {
      allowSelectBtn: true,
      orderCardType: orderCardType,
      selectOrderText: selectOrderText,
      totalText: totalText,
      itemText: itemText,
      itemsText: itemsText
    })), orderCardType !== OrderCardType.verticalList && orderCardType !== OrderCardType.twoRowCarousel && /*#__PURE__*/_react.default.createElement(_Button.Button, {
      className: "".concat(prefixCls, "-item-select-btn"),
      action: order.action,
      text: selectOrderText,
      onClick: function onClick() {
        return onOrderClick === null || onOrderClick === void 0 ? void 0 : onOrderClick();
      }
    }));
  };
  var renderMoreOrderBtn = function renderMoreOrderBtn(props) {
    var loadMoreOrderText = props.loadMoreOrderText;
    var shouldShowIcon = orderCardType !== OrderCardType.verticalList && orderCardType !== OrderCardType.twoRowCarousel;
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      className: (0, _clsx3.default)("".concat(prefixCls, "-more-btn"), 'chatbot-order-list-more-btn'),
      onClick: handleMoreOrderClick
    }, moreOrderTracking === null || moreOrderTracking === void 0 ? void 0 : moreOrderTracking.trackingImpressionProps), /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "-more-btn__container")
    }, shouldShowIcon && /*#__PURE__*/_react.default.createElement("img", {
      src: _order_others.default
    }), /*#__PURE__*/_react.default.createElement("span", null, loadMoreOrderText)));
  };
  var handleClosePopup = function handleClosePopup() {
    onClosePopup === null || onClosePopup === void 0 ? void 0 : onClosePopup();
    setShowPopup(false);
  };
  var orderScrollTrackHandler = function orderScrollTrackHandler() {
    if (orderListTrackData !== null && orderListTrackData !== void 0 && orderListTrackData.trackingScroll) {
      tracker.scroll(orderListTrackData.trackingScroll);
    }
  };
  var addScrollTrackEvent = function addScrollTrackEvent() {
    if (orderCardType === OrderCardType.twoRowCarousel) {
      if (ordersRef.current) {
        elementScrollTrack.addTrack(ordersRef.current, _elementScrollTrack.ScrollType.Horizontal, {
          scrollCallback: orderScrollTrackHandler,
          containerElement: ordersRef.current
        });
      }
    } else {
      if (containerRef.current) {
        elementScrollTrack.addTrack(containerRef.current, _elementScrollTrack.ScrollType.Horizontal, {
          scrollCallback: orderScrollTrackHandler,
          containerElement: containerRef.current
        });
      }
    }
  };
  (0, _react.useEffect)(function () {
    if (showPopup) {
      setShowTime(Date.now());
      return;
    }
    if (!showPopup && showTime && closePanelTrackingData !== null && closePanelTrackingData !== void 0 && closePanelTrackingData.trackingClick) {
      var _closePanelTrackingDa;
      var _trackingData = _objectSpread(_objectSpread({}, (closePanelTrackingData === null || closePanelTrackingData === void 0 ? void 0 : (_closePanelTrackingDa = closePanelTrackingData.trackingClick) === null || _closePanelTrackingDa === void 0 ? void 0 : _closePanelTrackingDa.data) || {}), {}, {
        view_duration: Math.floor((Date.now() - showTime) / 1000)
      });
      tracker.click(_objectSpread(_objectSpread({}, closePanelTrackingData === null || closePanelTrackingData === void 0 ? void 0 : closePanelTrackingData.trackingClick), {}, {
        data: _trackingData
      }));
      setShowTime(0);
    }
  }, [showPopup]);
  (0, _react.useEffect)(function () {
    addScrollTrackEvent();
    return function () {
      elementScrollTrack.removeAllTrack();
    };
  }, [orderCardType, orderListTrackData]);
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: containerRef // eslint-disable-next-line object-curly-newline
    ,

    className: (0, _clsx3.default)("".concat(prefixCls, "-container"), 'order-wrapper', "".concat(prefixCls, "-container-").concat(orderCardStyleMap[orderCardType]), (0, _defineProperty2.default)({}, "".concat(prefixCls, "-container-scroll"), showScrollbar === true))
  }, /*#__PURE__*/_react.default.createElement(_Popup.Popup, {
    title: panelTitleText || trans(_constants.BUYER_ORDER_LIST_TITLE_TEXT),
    showCloseIcon: true,
    active: showPopup,
    onClose: function onClose() {
      return handleClosePopup();
    },
    titleClassName: "".concat(prefixCls, "-popup__title"),
    contentClassName: "".concat(prefixCls, "-popup__content")
  }, /*#__PURE__*/_react.default.createElement(_ProductList.ProductListTabs, {
    tabs: tabs,
    onLoadMore: onLoadMore,
    selectOrderText: selectOrderText,
    defaultSelected: defaultSelected,
    itemText: itemText,
    itemsText: itemsText,
    showOrderId: showOrderId,
    showUserTypeTab: showUserTypeTab,
    onButtonClick: function onButtonClick(params) {
      _onButtonClick === null || _onButtonClick === void 0 ? void 0 : _onButtonClick(params);
      setShowPopup(false);
    },
    userTypes: userTypes,
    trackingData: trackingData,
    componentTrackingData: componentTrackingData,
    showLoading: showLoading,
    previewMockData: previewMockData,
    formatOrderListItem: formatOrderListItem,
    statusText: statusText
  })), /*#__PURE__*/_react.default.createElement("div", {
    ref: ordersRef,
    className: (0, _clsx3.default)("".concat(prefixCls, "-orders"), 'order-wrapper-orders', (0, _defineProperty2.default)({}, "".concat(prefixCls, "-orders-scroll"), showScrollbar === true))
  }, content.map(function (order, index) {
    return renderOrder({
      order: order,
      index: index
    });
  })), showMoreOrderButton && renderMoreOrderBtn({
    loadMoreOrderText: loadMoreOrderText
  }));
};
exports.OrderList = OrderList;